import { makeStyles } from '@material-ui/core'
import { memo } from 'react'
import SimpleLink from 'core/components/SimpleLink'
import Theme from 'core/themes/model'
import { routeManager } from 'core/utils/routes'
import { IVolumeDetailsPageTabs } from '../storage/volumes/volume-details/model'

const useStyles = makeStyles<Theme>((theme) => ({
  backingVolumesGrid: {
    display: 'grid',
    gap: '8px',
  },
}))

/**
 * Displays a list of backing volumes for a given image.
 * @param {Object} props.volumesByImageId - A mapping of image IDs to their corresponding backing volumes.
 * @param {string} props.imageId - The ID of the image for which to display backing volumes.
 * @returns {JSX.Element|string} A JSX element displaying the backing volumes or a placeholder if none exist.
 */
const BackingVolumesCell = ({ volumesByImageId, imageId }) => {
  const classes = useStyles()

  const backingVolumes = volumesByImageId[imageId] || []
  if (!backingVolumes.length) return '—'

  return (
    <div className={classes.backingVolumesGrid}>
      {backingVolumes.map((vol) => (
        <div key={vol.id}>
          {vol.volume_type && (
            <div>
              <b>{vol.volume_type}</b>
            </div>
          )}
          <SimpleLink
            src={routeManager.routes.openstack.volumeDetails.path({
              id: vol.id,
              tab: IVolumeDetailsPageTabs.Overview,
            })}
          >
            {vol.name || vol.id}
          </SimpleLink>
        </div>
      ))}
    </div>
  )
}

export default memo(BackingVolumesCell)
